import React from 'react';
import { Field, useForm } from 'react-final-form';
import { ReferenceInput, SelectInput, FormDataConsumer, REDUX_FORM_NAME } from 'react-admin';
import { AutocompleteInput, ArrayInput, SimpleFormIterator, NumberInput, required } from 'react-admin';
import IngredientQuickPreviewButton from './IngredientQuickPreviewButton';
import './formulation.css';

const IngredientNameField = (record) => `${record.brandname}, [${(record.substance_types[0] ? record.substance_types[0].name : '')}]` ;

const IngredientFormButton = ({ formData, scopedFormData, getSource, ...rest }) => {
  const form = useForm();
  return (
    <Field
      validate={required()}
      name={getSource("ingredient.ingredient_id")}
      component={
        ({ input }) => {
          return (
            input.value && <IngredientQuickPreviewButton ingredient_id={input.value} {...rest} />
          );
        }
      }
    />
  )
}

const TotalWeightCalculator = ({ formData, scopedFormData, getSource, ...rest }) => {
  const form = useForm();

  return(
    <NumberInput label="Quantity in [mg]" source={getSource("ingredient.quantity_of")} step={0.01} validate={required()} fullWidth={true} onChange={(event) =>{
      if(scopedFormData.ingredient){
        var total_weight = formData.composition.reduce((weight_total,item) => {
          //console.log("-")
          if(item.ingredient){
            var itemValue = parseFloat(item.ingredient.quantity_of)
            if(isNaN(itemValue)){
              itemValue = 0
            }
          }
          //console.log("  weight total: " + weight_total)
          //console.log("  itemValue: " + itemValue)
          return weight_total + itemValue
        }, 0)
        //console.log("total_weight: " + total_weight)

        var newValue = parseFloat(event.target.value)
        if(isNaN(newValue)){
          newValue = 0
        }

        if(newValue == ""){
          newValue = scopedFormData.ingredient.quantity_of * -1
        }

        var previousValue = scopedFormData.ingredient.quantity_of
        if(isNaN(previousValue)){
          previousValue = 0
        }

        if(event.target.value == ""){
          previousValue=0
        }

        //console.log("new Value: " + newValue)
        //console.log("previous Value: " + previousValue)
        //console.log("total_weight + new Value: " + (total_weight + newValue))
        //console.log("========================")

        form.change('total_weight', (total_weight + newValue - previousValue).toFixed(4))
      }
    }} />
  )
}

const IngredientQuantityInput = props => {
  return (
    <div>
      <ArrayInput label="Composition" source="composition" resource="formulation">
        <SimpleFormIterator>
          <ReferenceInput formClassName="substance" fullWidth={true} label="Ingredient" reference="ingredients" resource="ingredients" source="ingredient.ingredient_id"  basePath="/ingredients" sort={{ field: 'name', order: 'ASC' }} >
            <AutocompleteInput optionText="search_name" matchSuggestion={(filter, choice) => true }/>
          </ReferenceInput>
          {/* We use Field to get the current value of the `formulation_id` field */}
          <FormDataConsumer>
            {formDataProps => {
              return <IngredientFormButton {...formDataProps}/>
            }}
          </FormDataConsumer>
          <FormDataConsumer formClassName="quantity">
            {formDataProps => {
              return <TotalWeightCalculator {...formDataProps} />
            }}
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>

    </div>
  );
};

export default IngredientQuantityInput;
